import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/edit-place-controller';
import { Spinner } from 'components/design';
import { PlaceForm } from '../components/place-form';

export const EditPlaceRoute = () => {
    const {
        formData,
        terminals,
        cities,
        onChange,
        onSubmit,
        onCancel,
        dataChanged,
        isLoading,
        isEditPlaceLoading,
        errors,
        isAdmin,
        deliveryZonePlaceConfig,
        onDeliveryPriceChange,
        website,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <PlaceForm
                    formData={formData}
                    terminals={terminals}
                    cities={cities}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditPlaceLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                    deliveryZonePlaceConfig={deliveryZonePlaceConfig}
                    onDeliveryPriceChange={onDeliveryPriceChange}
                    website={website}
                />
            )}
        </OWContainer>
    );
};
